import request from '@/utils/request.js'

// 订单流水列表
function flowingList(data) {
    return request({
        url: '/api/v1/tob/flowing-list',
        method: 'get',
        params:data
    })
}

// 机构订单列表
function orderList(data) {
    return request({
        url: '/api/v1/tob/order-list',
        method: 'get',
        params:data
    })
}


// 取消订单 
function cancelOrder(data) {
    return request({
        url: `/api/v1/tob/cancel-order/${data.id}`,
        method: 'post',
        data
    })
}

// 提交退费申请
function refundOrder(data) {
    return request({
        url: `/api/v1/tob/refund-order/${data.id}`,
        method: 'get',
        params:data
    })
}

// 退费列表
function refundList(data) {
    return request({
        url: `/api/v1/tob/refund-list`,
        method: 'get',
        params:data
    })
}

// 招生表单  /api/v1/tob/recruit-data
function recruitData(data) {
    return request({
        url: `/api/v1/tob/recruit-data`,
        method: 'get',
        params:data
    })
}

// 获取二维码分享图 
function tobShareImg(data) {
    return request({
        url: '/api/v1/tob/shareimg',
        method: 'post',
        data
    })
}

// 推广者姓名下拉框列表 /api/v1/tob/admin-teacher-list-realname-select
function getExtendNameList(data) {
    return request({
        url: `/api/v1/tob/admin-teacher-list-realname-select`,
        method: 'get',
        params:data
    })
}

export default{
    flowingList,
    orderList,
    cancelOrder,
    refundOrder,
    refundList,
    recruitData,
    tobShareImg,
    getExtendNameList
}